module.exports = __webpack_public_path__ + "h5/img/trade_success.886d6943.png";